<div class="contact-page">
  <app-navbar page="contact"></app-navbar>

  <!-- Page Hero -->
  <section class="contact-hero">
    <h2 class="eyebrow centered">Contact Us</h2>
    <h1 class="contact-hero-title">Get in Touch</h1>
    <p class="contact-hero-subtitle">
      Have a question, partnership idea, or want to bring e-Likita to your facility?
      We'd love to hear from you.
    </p>
  </section>

  <!-- Contact details + form -->
  <section class="contact-body">
    <div class="contact-details">
      <h3 class="section-title">Reach Us Directly</h3>

      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <mat-icon>email</mat-icon>
        </div>
        <div>
          <p class="contact-label">Email</p>
          <a [href]="'mailto:' + contactDetails.email" class="contact-value">{{ contactDetails.email }}</a>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <mat-icon>call</mat-icon>
        </div>
        <div>
          <p class="contact-label">Phone</p>
          <a *ngFor="let phone of contactDetails.phones" [href]="'tel:' + phone" class="contact-value contact-phone">
            {{ phone }}
          </a>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <mat-icon>location_on</mat-icon>
        </div>
        <div>
          <p class="contact-label">Address</p>
          <p class="contact-value">{{ contactDetails.address }}</p>
        </div>
      </div>
    </div>

    <div class="contact-form-card">
      <h3 class="section-title">Send Us a Message</h3>
      <form class="contact-form">
        <label class="form-field">
          <span>Full Name</span>
          <input type="text" name="name" placeholder="Your name" required>
        </label>
        <label class="form-field">
          <span>Email Address</span>
          <input type="email" name="email" placeholder="you@example.com" required>
        </label>
        <label class="form-field">
          <span>Message</span>
          <textarea name="message" rows="5" placeholder="How can we help?" required></textarea>
        </label>
        <button type="submit" class="contact-submit-btn">Send Message</button>
      </form>
    </div>
  </section>

  <app-footer></app-footer>
</div>